import { Button } from "@colorglo/ui/components";
import { ActionCart, iconSize } from "@colorglo/ui/icons";
import { Link } from "@tanstack/react-router";
import { useCart } from "../../lib/cart.ts";
import { useT } from "../../lib/locale.ts";

export function CartButton({ franchiseId }: { readonly franchiseId: string | null }) {
  const t = useT();
  const cart = useCart(franchiseId);

  return (
    <Button
      asChild
      variant="ghost"
      size="icon"
      className="relative"
      aria-label={cart.count > 0 ? `${t("shop.cart.title")} (${cart.count})` : t("shop.cart.title")}
    >
      <Link to="/butik/varukorg">
        <ActionCart {...iconSize.control} aria-hidden="true" />
        {cart.count > 0 && (
          <span
            aria-hidden="true"
            className="absolute -top-0.5 -right-0.5 flex min-w-4 items-center justify-center rounded-full bg-brand-strong px-1 text-[10px] font-medium leading-4 text-on-brand"
          >
            {cart.count > 99 ? "99+" : cart.count}
          </span>
        )}
      </Link>
    </Button>
  );
}
